<div class="flex flex-row !px-4 !pt-4 justify-between relative items-center">
  <h2 mat-dialog-title class="dialog-heading !text-base">{{ heading }}</h2>
  <button mat-icon-button class="flex items-center justify-center" (click)="onClose()">
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>

<div class="px-4 relative overflow-y-auto" style="height: calc(100dvh - 135px)">
  <div class="flex flex-col gap-[10px]" *ngIf="locations?.length; else noLocation">
    <ng-container *ngFor="let location of locations">
      <div (click)="onSelectLocation(location)" [ngClass]="
          'transition-colors duration-150 rounded-lg ' +
          (isLocationSelectedForCurrentGroup(location.locationId)
            ? 'bg-[#FBF4F1] border border-[#F54720] cursor-pointer'
            : isLocationSelected(location.locationId)
            ? 'bg-gray-100 border border-[#F54720] cursor-not-allowed opacity-60'
            : 'bg-white cursor-pointer')
        "
        [matRipple]="!isLocationSelected(location.locationId) || isLocationSelectedForCurrentGroup(location.locationId)">
        <div class="flex gap-2 p-2 w-full">
          <div>
            <img src="/assets/images/ui/location.svg" class="pt-1.5" alt="image" />
          </div>
          <div class="flex flex-col w-full justify-between items-start">
            <div class="flex w-full justify-between">
              <div class="flex items-center gap-2">
                <h4 class="line-clamp-1 text-black-color font-medium text-base">
                  {{ location.name | titlecase }}
                </h4>
                <span *ngIf="isLocationSelectedForCurrentGroup(location.locationId)"
                  class="text-xs bg-blue-theme-color text-white-color px-2 py-1 rounded-full">
                  Selected
                </span>
              </div>
              <div class="flex gap-1.5 ml-2">
                <button *ngIf="
                    !locationIdChecker(location.locationId) &&
                    !isLocationSelected(location.locationId)
                  " (click)="onDeleteAddress(location); $event.stopPropagation()" class="!p-0 !h-[18px]"
                  [disabled]="isLocationSelected(location.locationId) && !isLocationSelectedForCurrentGroup(location.locationId)">
                  <mat-icon class="text-red">delete_outline</mat-icon>
                </button>
                <button class="!p-0 !h-[18px]"
                  [disabled]="isLocationSelected(location.locationId) && !isLocationSelectedForCurrentGroup(location.locationId)">
                  <mat-icon
                  class="text-light-orange">arrow_forward</mat-icon>
                </button>
              </div>
            </div>
            <p class="text-sm line-clamp-2 text-black-color font-normal mt-1">
              {{ location.address | titlecase }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #noLocation>
    <div class="flex h-full items-center justify-center">
      <p class="md:text-lg sm:text-base text-base font-light text-center text-dialog-label">
        You Haven’t Added Any {{ isPickup ? "Pickup" : "Dropoff" }} Locations.
      </p>
    </div>
  </ng-template>

  <div class="fixed right-0 bottom-0 !w-[350px] px-4 pb-4 z-10 flex justify-center">
    <button
      class="bg-orange-500 hover:bg-orange-600 text-white-color bg-blue-theme-color font-semibold py-3 px-6 rounded-lg shadow-md w-full max-w-md"
      (click)="onNewLocation()">
      {{ isPickup ? "Add Pickup Location" : "Add Drop Off Location" }}
    </button>
  </div>
</div>